// extracted by mini-css-extract-plugin
export default {"AgentSection":"AgentViewBlock_AgentSection__m32zh"};